<template>
  <div>
    <div v-if="spinners.contentIsLoading" class="text-center mt-5 mb-5">
      <b-spinner type="grow" variant="primary"/>
    </div>
    <b-row v-else class="card-body">
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <div class="container mt-5 mb-5">
              <div class="row">
                <ul class="timeline">
                  <li v-for="(item, key) in items" :key="key">
                    <span class="color-info"><strong>{{ item.created_at }}</strong></span>
                    <p>{{ item.description | translate('historyLogs') }}</p>
                    <blockquote class="blockquote">
                      <p v-if="item.comment.length" class="mb-0 history-comment text-secondary" >
                        <i class="fa fa-comment text-secondary small"/> {{ item.comment }}</p>
                      <footer class="blockquote-footer"><cite>{{ item.causer }}</cite></footer>
                    </blockquote>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <!--Paginator-->
          <b-col cols="12" v-if="items.length">
            <Pagination align="center" :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import VuexTypes from '@/store/types/index';
import Pagination from 'laravel-vue-pagination';

const InvoiceTypes = VuexTypes.invoices;

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      items: [],
    };
  },
  components: {
    Pagination,
  },
  computed: {
    ...mapGetters('Invoices', [
      'invoiceActivity',
      'invoiceUpdateData',
    ]),
    listPaginator() {
      return this.invoiceActivity.data.meta;
    },
    list() {
      return this.invoiceActivity;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    invoiceActivity: {
      handler: function () {
        if (this.invoiceActivity.status === statuses.LOADED) {
          this.spinners.contentIsLoading = false;
          this.fillTableData();
        }
      },
      deep: true
    },
    invoiceUpdateData: {
      handler: function () {
        if (this.invoiceUpdateData.status === statuses.LOADED) {
          this.getData();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Invoices', [
      InvoiceTypes.INVOICE_ACTIVITY
    ]),
    getData() {
      const page = this.page ? this.page : '1';
      this.INVOICE_ACTIVITY({ id: this.$route.params.id, page });
    },
    fillTableData() {
      const result = [];
      forEach(this.list.data.data, (log) => {
        let comment = '';
        if (log['properties']['attributes']) {
          if (log['properties']['attributes']['comment']) {
            comment = log['properties']['attributes']['comment'];
          } else if (log['properties']['attributes']['notes']) {
            comment = log['properties']['attributes']['notes'];
          }
        }

        result.push({
          created_at: log['created_at'],
          causer: log['causer'] ? log['causer']['full_name'] : null,
          description: this.$t(log['description'], 'global'),
          comment: comment
        });
      });

      this.items = result;
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'InvoiceUpdate', params: { id: this.$route.params.id, tab: 'history', page } });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  ul.timeline {
    list-style-type: none;
    position: relative;
    &:before {
      content: ' ';
      background: #d4d9df;
      display: inline-block;
      position: absolute;
      left: 29px;
      width: 2px;
      height: 100%;
      z-index: 400;
    }
    > li {
      margin: 20px 0;
      padding-left: 20px;
      &:before {
        content: ' ';
        background: white;
        display: inline-block;
        position: absolute;
        border-radius: 50%;
        border: 3px solid #F7B334;
        left: 20px;
        width: 20px;
        height: 20px;
        z-index: 400;
      }
    }
  }
  .history-comment {
    font-size: 16px;
    font-style: italic;
  }
</style>
